import { useQuery } from "@tanstack/react-query";
import { fetchAllLocations } from "utils";
import { EventLocation } from "types";
import { useAuthentication } from "context/AuthenticationContext";

export const getEventLocationsQueryKey = (userId: string) => ["event_locations", userId];

export const useEventLocations = () => {
    const auth = useAuthentication();

    const { data: locations = [], refetch: getLocations } = useQuery<EventLocation[]>({
        queryKey: getEventLocationsQueryKey(auth.user?.id || ""),
        queryFn: async () => {
            const data = await fetchAllLocations({
                sort: "created_at:asc",
                search: "",
            });
            return data ? data.data : [];
        },
        enabled: auth.isAuthenticated && !!auth.user,
    });

    return { locations, getLocations };
};
